import { BooleanSelectOption, SelectOption } from '@storage/app/models'
import { useTranslate } from '@tolgee/react'
import { useMemo } from 'react'

export const useReeferOptions = (): SelectOption[] => {
  const { t } = useTranslate()

  return useMemo(
    () => [
      { label: t(`reefer`), value: BooleanSelectOption.True },
      { label: t(`nonReefer`), value: BooleanSelectOption.False },
    ],
    [t],
  )
}
